<template>
  <div class="h-full relative">
    <!-- <div class="mobile-padding"></div> -->
    <div
      class="h-full  overflow-auto bg-gradient-to-b from-white via-primary/10 to-primary-50 overflow-x-hidden flex-col-reverse flex"
    >
      <div class="fixed top-0 z-[10] w-full">
        <div
          class="bg-gradient-to-b from-primary-100 to-primary-50/80 backdrop-blur-sm "
        >
          <div class="mobile-status-padding"></div>
          <div class="grid grid-cols-3 px-5">
            <div class="py-5 pl-7">
              <div
                class="bg-gradient-to-br  pb-5 -mb-5 flex justify-center drop-shadow-lg"
              >
                <div class="w-[70%]">
                  <div class="py-[50%] relative -mb-4">
                    <ImgComponent
                      :src="userData?.profilePictureUrl || userData?.email"
                      :avatar="!userData?.profilePictureUrl"
                      class="absolute shimmerTarget w-full h-full top-0 left-0 rounded-full"
                    />
                  </div>
                </div>
              </div>
              <div
                class="shaddow-2xl p-4 bg-white/90 backdrop-blur-sm rounded-2xl shimmerTarget drop-shadow-xl text-center w-[130%] -translate-x-[12%]"
              >
                <div
                  class="text-sm font-semibold whitespace-nowrap text-gray-700 "
                  :class="{ 'opacity-0': !isElligible }"
                >
                  <span class="text-primary-600"
                    >{{
                      isElligible
                        ? Math.max(currentUserLevelData?.requiredLevelXp -
                          currentUserLevelData?.currentXp, 0)
                        : '.'
                    }}
                    XP</span
                  >
                  restants
                </div>
                <div class="relative flex items-center mt-3">
                  <div
                    class="absolute h-12 w-12 left-0 -translate-x-1/2 bg-gradient-to-br from-primary to-primary-600 rounded-full flex items-center justify-center drop-shadow-lg ring-4 ring-white z-2"
                    :class="{ 'opacity-0': !isElligible }"
                  >
                    <div class="text-white text-2xl font-bold">
                      {{ currentUserLevelData?.level }}
                    </div>
                  </div>
                  <div
                    class="w-full h-10 bg-gradient-to-r from-primary-100 to-primary-200 rounded-full overflow-hidden"
                  >
                    <div
                      :style="{
                        width: `${currentUserLevelData?.currentLevelXpProgress || 0}%`
                      }"
                      :class="{
                        'duration-700': true
                      }"
                      class="h-full bg-gradient-to-r from-primary-900 to-primary rounded-full relative overflow-hidden drop-shadow-lg"
                    >
                      <div
                        class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-[shimmer_2s_infinite]"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-5 col-span-2">
              <div class="text-sm text-gray-500 mt-1 font-medium">
                Effectuez des taches &
                <br />
                Gagnez des récompenses
              </div>
              <div
                class="text-3xl title-color font-bold whitespace-nowrap bg-gradient-to-r from-primary to-orange-500 bg-clip-text text-transparent"
              >
                Rapidoo
                <br />
                connect
              </div>
            </div>

            <div
              class="absolute w-1/3 right-0 bottom-0 flex justify-end mt-auto items-end"
            >
              <div class="min-w-[130%] -mb-8">
                <ImgComponent
                  src="/images/others/montain.webp"
                  alt=""
                  class="drop-shadow-xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative -my-10 px-5">
        <div class="py-32"></div>
        <!-- Reward Onboarder - handles user onboarding and level animations -->
        <RewardOnboarder ref="onboarderRef" />

        <!-- Rewards List - shows level progression and milestones -->
        <RewardsList
          ref="rewardsListRef"
          @itemClick="
            (el) => {
              bus.emit(constants.EVENTS.REWARDS.DETAIL_REQUIRED, el);
            }
          "
        />
      </div>
    </div>
    <div
      class=""
      v-if="
        currentUserLevelData &&
        !currentUserLevelData?.isElligible &&
        !profileLoading
      "
    >
      <div
        class="fixed bottom-52 left-1/2 -translate-x-1/2 pointer-events-auto z-8"
        @click="startRapidooConnect"
      >
        <div
          class="buttonComponent bg-gradient-to-r from-primary to-orange-500 text-white drop-shadow-lg hover:drop-shadow-xl transform hover:scale-105 transition-all duration-300 font-bold px-8 py-4 rounded-full text-lg border-2 border-white/50"
        >
          <span class="flex items-center gap-2">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                clip-rule="evenodd"
              />
            </svg>
            Démarrer l'aventure
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <RewardRules/>
      <BadgesList/>
      <RewardMilestones/>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import constants from '@core/utils/constants';
import RewardOnboarder from '../components/RewardOnboarder.vue';
import RewardRules from '../components/RewardRules.vue';
import RewardsList from '../components/RewardsList.vue';
import RewardMilestones from '../components/RewardMilestones.vue';
import BadgesList from '../components/BadgesList.vue';

const store = getStore('rewards');
const userStore = getStore('user');

// Component refs
const onboarderRef = ref(null);
const rewardsListRef = ref(null);

// State
const makeWelcomeOnboarding = ref(false);
const profileLoading = ref(true);

// Store state - using the same naming as v2 for consistency
const currentUserLevelData = computed(() => store.state.userLevelData);
const userData = computed(() => userStore?.state?.current || {});

// Eligibility check - matches v2 exactly
const isElligible = computed(() => {
  return currentUserLevelData.value?.isElligible;
});

// Start Rapidoo Connect - matches v2 exactly
function startRapidooConnect() {
  makeWelcomeOnboarding.value = true;
  bus.emit(constants.EVENTS.REWARDS.START);
}

// Watch for eligibility changes to trigger onboarding - matches v2 exactly
watch(isElligible, (newVal) => {
  console.log('🚀 ~ newVal:', newVal);
  if (newVal !== true || makeWelcomeOnboarding.value !== true) return;
  rewardsListRef.value?.makeWelcomeOnboarding();
});

// Listen for profile loaded to stop loading state
bus.on(constants.EVENTS.REWARDS.PROFILE_LOADED, () => {
  console.log(
    '🎮 PROFILE_LOADED event received, setting profileLoading to false'
  );
  profileLoading.value = false;
});

// Watch userLevelData changes
watch(
  currentUserLevelData,
  (newVal) => {
    console.log('🎮 currentUserLevelData changed:', newVal);
  },
  { immediate: true }
);

// Computed for button visibility (for debugging)
const shouldShowButton = computed(() => {
  const result = !!(
    currentUserLevelData.value &&
    !currentUserLevelData.value?.isElligible &&
    !profileLoading.value
  );
  console.log('🎮 Button visibility check:', {
    hasData: !!currentUserLevelData.value,
    isElligible: currentUserLevelData.value?.isElligible,
    profileLoading: profileLoading.value,
    shouldShow: result
  });
  return result;
});

onMounted(() => {
  const userStore = getStore('user');
  const isLoggedIn = userStore?.state?.isLoggedIn;

  // Only fetch gamification profile if user is logged in
  if (isLoggedIn) {
    bus.emit(constants.EVENTS.REWARDS.FETCH_PROFILE);
  } else {
    // Not logged in, stop loading
    profileLoading.value = false;
  }

  // Load levels data (RewardsList component will handle the display)
  bus.emit(constants.EVENTS.REWARDS.LOAD_LEVELS);
});
</script>
